import {ModalHeader} from '@/components/ui/modal-atoms/ModalAtoms'
import styled, {css} from 'styled-components'

export const StyledAccountModalSection = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        display: grid;
        grid-template-columns: 240px 1fr auto;
        padding: ${spacing * 6}px;
        border-bottom: 1px solid ${palette.neutral['200']};

        & p {
            ${typography.textMd};
        }
    `
)

export const StyledAccountModalSectionTitle = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral['950']};
        font-weight: 500;
    `
)

export const StyledAccountModalHeader = styled(ModalHeader)(
    ({theme: {spacing, palette, typography}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        height: 60px;
        border-bottom: none;
        outline: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 4}px ${spacing * 6}px;
        & > h3 {
            ${typography.textLg};
            color: ${palette.neutral.black};
            font-weight: 500;
            line-height: 24px;
        }
    `
)
